import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editResource(request: Boundaries["editResource"]["request"]): void;
}

function useEditResource(resource: Identifiable<Resource>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditResourceRequestFailure(resource),
    ),
    editResource: core.editResource,
  };
}

export { useEditResource };
